
export function jsonToSubscope7(standort_tid: number, tid: number, name: string, jahr: number, mitarbeiter: number, results: any, datenherkunft: number) {
    const rows: any[] = [];
    const transportation = results.transportation;
    const uebernachtung = results.uebernachtung;
    const mitarbeiter_erfasst = results.count;
    const faktor_hochrechnung = (mitarbeiter / mitarbeiter_erfasst) || 1;
    if (transportation) {
        Object.keys(transportation).forEach((k: string, i: number) => {
            const vals = transportation[k];
            const item = { ...getBaseItem(`${tid}_t${i + 1}`) };
            item.standort_tid = standort_tid;
            item.standort_tid_orig = standort_tid;
            item.jahr = jahr;
            item.mitarbeiter = name;
            item.entfernung = vals.km * faktor_hochrechnung;
            item.transportmittel = k;
            item.datenherkunft = datenherkunft;
            item.bewertung_emissionsfaktor = 1;
            // WKETOOL-125: Kraftstoff Autos
            if (item.transportmittel.indexOf('&kraftstoff=') !== -1) {
                const keyArr = item.transportmittel.split('&kraftstoff=');
                item.transportmittel = keyArr[0];
                item.kraftstoff = keyArr[1];
            }
            rows.push(item);
            // console.log(name, jahr, faktor_hochrechnung, item);
        });
    }
    if (uebernachtung) {
        Object.keys(uebernachtung).forEach((k: string, i: number) => {
            const vals = uebernachtung[k];
            const item = { ...getBaseItem(`${tid}_u${i + 1}`) };
            item.standort_tid = standort_tid;
            item.standort_tid_orig = standort_tid;
            item.jahr = jahr;
            item.mitarbeiter = name;
            item.entfernung = 0;
            item.uebernachtungen_anzahl = vals.uebern * faktor_hochrechnung;
            item.unterkunft = k;
            item.modus = 'none';
            rows.push(item);
        });
    }
    return rows;
}

function getBaseItem(id: string): any {
    return {
        // tid: -999,
        tid: `kampagne_${id}`,
        standort_tid: 0,
        standort_tid_orig: 0,
        jahr: 0,
        parent_tid: 0,
        mitarbeiter: '', // name
        arbeitstage: 1,
        teilstrecken: 'Nein',
        teilstrecken_orig: 2,
        entfernung: 0,
        transportmittel: '',
        kraftstoff: '',
        bemerkung: '',
        mandant: '',
        modus: 'distance_based',
        kosten: 0,
        energietraeger_tid: 0,
        verbrauch: 0,
        uebernachtungen_anzahl: null,
        unterkunft: null,
        anhang: ''
    };
}
